(function () {
  let imgCounter = 1;
  document.querySelectorAll("img").forEach((img) => {
    if (!img.hasAttribute("alt") || img.alt.trim() === "") {
      let altText = `Shopify Image ${imgCounter}`;
      imgCounter++;
      let productContainer = img.closest(".product-card, .product-item");
      if (productContainer) {
        let productTitle = productContainer.querySelector(
          ".product-title, .product-name"
        );
        if (productTitle && productTitle.innerText.trim() !== "") {
          altText = `${productTitle.innerText.trim()} Image ${imgCounter}`;
        }
      }
      img.setAttribute("alt", altText);
    }
  });
})();




var intervalID = setInterval(() => {
  var bannerTitle = document.querySelector('#shopify-pc__banner #shopify-pc__banner__body-title');    
    //console.log("Running...",bannerTitle);
    if (bannerTitle) {
      const h2 = document.createElement("p");
      h2.innerHTML = bannerTitle.innerHTML;
      h2.className = bannerTitle.className; // Preserve class
      h2.id = "shopify-pc__banner__body-title"; // Preserve ID
      bannerTitle.replaceWith(h2);
      clearInterval(intervalID);
    }
}, 1000);